export type SelfServePlan = "solo" | "teams";

export function parseSelfServePlan(
  value: string | null | undefined,
): SelfServePlan | null {
  if (value === "solo" || value === "teams") return value;
  return null;
}

export function afterAuthPath(plan: SelfServePlan | null): string {
  return plan === null ? "/" : `/?plan=${plan}`;
}

export function sameOriginRedirectPath(
  value: string | null | undefined,
): string | null {
  if (value === null || value === undefined || value.length === 0) return null;
  if (!value.startsWith("/") || value.startsWith("//")) return null;
  if (value.includes("://") || value.includes("\\")) return null;
  return value;
}

export function afterAuthRedirect(params: URLSearchParams): string {
  const redirect = sameOriginRedirectPath(params.get("redirect_url"));
  if (redirect !== null) return redirect;
  return afterAuthPath(parseSelfServePlan(params.get("plan")));
}

export function authPathWithReturn(
  path: "/sign-in" | "/sign-up",
  input: {
    readonly plan?: SelfServePlan | null;
    readonly redirectUrl?: string | null;
  } = {},
): string {
  const query = new URLSearchParams();
  if (input.plan === "solo" || input.plan === "teams") {
    query.set("plan", input.plan);
  }
  const redirect = sameOriginRedirectPath(input.redirectUrl ?? null);
  if (redirect !== null) query.set("redirect_url", redirect);
  const encoded = query.toString();
  return encoded.length === 0 ? path : `${path}?${encoded}`;
}

export function organizationInvitePath(token: string): string {
  return `/invite?token=${encodeURIComponent(token)}`;
}

export function afterBillingSetupPath(organizationId: string): string {
  return `/org/${organizationId}/setup`;
}

export function signedOutAuthDestination(
  pathname: string,
  search: string,
): string | null {
  if (pathname === "/sign-in" || pathname.startsWith("/sign-in/")) {
    return null;
  }
  if (pathname === "/sign-up" || pathname.startsWith("/sign-up/")) {
    return null;
  }
  const query = search.startsWith("?") ? search.slice(1) : search;
  const plan = parseSelfServePlan(new URLSearchParams(query).get("plan"));
  if (pathname === "/" || pathname === "" || pathname === "/index.html") {
    return plan === null ? "/sign-in" : `/sign-up?plan=${plan}`;
  }
  const redirect = `${pathname}${search}`;
  return `/sign-in?redirect_url=${encodeURIComponent(redirect)}`;
}
